import { DemoEvent, EventProperties } from '../posthog';

interface DemoPageEvent {
  eventName: string;
  properties: EventProperties;
}

const withDefinedProperties = (properties: EventProperties): EventProperties =>
  Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined && value !== null));

export const getDemoPageViewEvent = (pathname: string, search = ''): DemoPageEvent | null => {
  const segments = pathname.split('/').filter(Boolean);
  const path = `${pathname}${search}`;

  if (segments[0] !== 'repositories' || !segments[1]) {
    return null;
  }

  const applicationId = segments[1];
  const section = segments[2];
  const baseProperties = {
    application_id: applicationId,
    path,
  };

  if (!section) {
    return {
      eventName: DemoEvent.APPLICATION_PAGE_VIEWED,
      properties: baseProperties,
    };
  }

  if (section === 'settings' && segments[3] === 'source' && segments.length === 4) {
    return {
      eventName: DemoEvent.REPOSITORIES_PAGE_VIEWED,
      properties: baseProperties,
    };
  }

  if (section === 'scans') {
    if (segments[3]) {
      return {
        eventName: DemoEvent.SCAN_PAGE_VIEWED,
        properties: withDefinedProperties({
          ...baseProperties,
          scan_batch_id: segments[3],
          scan_id: segments[4],
        }),
      };
    }

    return {
      eventName: DemoEvent.SCANS_PAGE_VIEWED,
      properties: baseProperties,
    };
  }

  if (section === 'findings') {
    if (segments[3]) {
      return {
        eventName: DemoEvent.FINDING_PAGE_VIEWED,
        properties: {
          ...baseProperties,
          finding_id: segments[3],
        },
      };
    }

    return {
      eventName: DemoEvent.FINDINGS_PAGE_VIEWED,
      properties: baseProperties,
    };
  }

  if (section === 'fixes') {
    if (segments[3]) {
      return {
        eventName: DemoEvent.FIX_PAGE_VIEWED,
        properties: {
          ...baseProperties,
          fix_id: segments[3],
        },
      };
    }

    return {
      eventName: DemoEvent.FIXES_PAGE_VIEWED,
      properties: baseProperties,
    };
  }

  return null;
};
